<template>
    <v-menu
        v-model="value"
        class="dropdown-menu"
        bottom
        left
        :offset-x="true"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
                :class="buttonClasses"
            >
                <img v-if="!value" src="@/assets/images/components/menu-horizontal.svg" class="right pointer mr-2">
                <img v-if="value" src="@/assets/images/components/menu-horizontal-active.svg" class="right pointer mr-2">
            </v-btn>
        </template>

        <v-list class="dropdown-menu-list">
            <v-list-item class="pointer" v-for="(action, i) in actions" :key="i">
                <v-list-item-title @click="handle(action.handler)">{{ action.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'

    export default Vue.extend({
        props: {
            actions: Array, 
            buttonClasses: String,
        },
        components: {

        },
        data() {
            return {
                value: false,
                
            }
        },
        computed: {

        },
        methods: {
            async handle(handler) {
                await handler()
                this.value = false
            }
        },
    })

    </script>

<style lang="scss">
    .dropdown-menu-list.v-list{
        padding: 0;
        .v-list-item__title{
            font-size: small;
        }
    }
</style>

<style lang="scss" scoped>

</style>
